<template>
  <div>
    <div
      v-if="!show"
      class="spinner-loader"
    >
      <sync-loader />
      <p>Loading ...</p>
    </div>
    <div
      v-if="show"
      class="content"
    >
      <h1 class="has-text-centered">
        My Points
      </h1>
      <hr>
      <modale-image
        v-if="showPreview"
        :image="user.memberphoto"
        @closeModal="closeModal"
      />
      <div class="columns">
        <div class="column is-3 column-avatar">
          <div class="card-avatar">
            <img
              v-if="user.memberphoto"
              :src="user.memberphoto"
              @click="previewImage()"
            >
            <img
              v-if="!user.memberphoto"
              src="/images/profile.png"
              @click="previewImage()"
            >
            <div class="file is-boxed">
              <label class="file-label">
                <input
                  ref="profile"
                  class="file-input"
                  type="file"
                  name="resume"
                  @change="uploadImage"
                >
                <i class="far fa-camera" />
                <small class="is-size-7">Update Picture</small>
              </label>
            </div>
          </div>
        </div>
        <div class="column is-9">
          <div class="div-table">
            <div class="columns is-gapless is-flex">
              <div class="column is-3 card-header has-text-centered">
                <strong class="is-size-7-touch">AHL#</strong>
              </div>
              <div class="column is-3 card-header has-text-centered">
                <strong class="is-size-7-touch">Name</strong>
              </div>
              <div class="column is-3 card-header has-text-centered">
                <strong class="is-size-7-touch">Handle</strong>
              </div>
              <div class="column is-3 card-header has-text-centered">
                <strong class="is-size-7-touch">Location</strong>
              </div>
            </div>
            <div class="columns is-gapless is-flex">
              <div class="column is-3 has-text-centered">
                <span class="has-text-danger is-size-7">{{ user.ahlid }}</span>
              </div>

              <div class="column is-3 has-text-centered">
                <span class="is-size-7">{{ fullName }}</span>
              </div>

              <div class="column is-3 has-text-centered">
                <span class="is-size-7">{{ mypoints.general.handle }}</span>
              </div>

              <div class="column is-3 has-text-centered">
                <span class="is-size-7">{{ mypoints.general.state }}</span>
              </div>
            </div>
            <div class="columns is-gapless">
              <div class="column is-12 has-text-centered">
                <span class="is-size-7 has-text-info">Compare points against another player.</span>
                <div class="columns">
                  <div class="column is-half no-bordered game-search">
                    <div class="field has-addons">
                      <div class="control">
                        <input
                          v-model="comparison"
                          class="input is-small"
                          type="text"
                          placeholder="AHL#"
                          @keyup.enter="compare()"
                        >
                      </div>
                      <div
                        class="control"
                        @click="compare()"
                      >
                        <a class="button is-black is-small">
                          <div class="is-pulled-right">Compare</div>
                          <span class="icon is-right">
                            <i class="far fa-search" />
                          </span>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div class="column no-bordered">
                    <span
                      v-if="!friends"
                      class="has-text-info"
                    >FriendList Empty</span>
                    <div class="control">
                      <div
                        class="dropdown is-fullwidth"
                        :class="{'is-active': isActive}"
                        @click="isActive = !isActive"
                      >
                        <div class="dropdown-trigger is-fullwidth">
                          <button
                            class="button is-fullwidth is-small"
                            aria-haspopup="true"
                            aria-controls="dropdown-menu"
                            style="background-color: #4267B2"
                          >
                            <span class="has-text-white">Friends List</span>
                            <span class="icon is-small">
                              <i
                                class="far fa-angle-down has-text-white"
                                aria-hidden="true"
                              />
                            </span>
                          </button>
                        </div>
                        <div class="dropdown-menu friendlist is-fullwidth">
                          <div class="dropdown-content">
                            <div
                              v-for="(player, index) in friends"
                              class="dropdown-item is-flex align-center"
                            >
                              <div class="is-flex is-centered">
                                <img
                                  v-if="!player.memberphoto"
                                  src="/images/img_default.jpg"
                                  class="img-circle"
                                >
                                <img
                                  v-if="player.memberphoto"
                                  :src="player.memberphoto"
                                  class="img-circle"
                                >
                                <router-link :to="{path: `/players/${player.ahlid}`}">
                                  <span class="is-size-7">{{ player.name }}</span>
                                </router-link>
                              </div>

                              <button
                                class="is-small delete"
                                @click="removeFriend(player.ahlid, index)"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        v-if="mypoints.totalPlacements && mypoints.tournamentHistory"
        class="columns"
      >
        <div class="column is-8">
          <point-races :races="races" />
          <tournament-history
            v-if="mypoints.tournamentHistory"
            :player="mypoints"
          />
          <ahl-stars :stars="mypoints.stars"/>
        </div>
        <div class="column is-4">
          <quick-stats
            :tournament-type="tournamentType"
            :player="mypoints"
            @tourntypechanged="tournTypeChanged"
          />

          <overall-placement
            :tournament-type="tournamentType"
            :player="mypoints"
            @tourntypechanged="tournTypeChanged"
          />

          <venue-stats :player="mypoints" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import axios from 'axios'
  import ModaleImage from '../ModalImage.vue'
  import PointRaces from '../players/PointRaces.vue'
  import TournamentHistory from '../players/TournamentHistory.vue'
  import QuickStats from '../players/QuickStats.vue'
  import OverallPlacement from '../players/OverallPlacement.vue'
  import VenueStats from '../players/VenueStats.vue'
  import AhlStars from "@/components/players/AhlStars";
  export default {
    name: 'MyPoints',
    components: {
      AhlStars,
      ModaleImage,
      PointRaces,
      TournamentHistory,
      QuickStats,
      OverallPlacement,
      VenueStats
    },
    metaInfo: {
      title: 'AHL Poker :: My Points'
    },
    props: ['user', 'token'],
    data () {
      return {
        mypoints: '',
        options: ['Year', 'Last Month', 'This Month'],
        comparison: '',
        tournamensFilter: false,
        show: false,
        friends: '',
        isActive: false,
        races: '',
        showPreview: false,
        tournamentType: 'Texas_Holdem'
      }
    },
    computed: {
      fullName () {
        return `${this.user.first} ${this.user.middle} ${this.user.last}`
      }
    },
    watch: {
      user: {
        memberphoto (val) {
          console.log(val)
        }
      }
    },
    mounted () {
      if (!this.user) {
        this.$router.push('/')
      }
      this.getMemberPoints()
      this.getFriends()
    },
    methods: {
      tournTypeChanged: function (tournType) {
        this.tournamentType = tournType
      },
      previewImage () {
        this.showPreview = !this.showPreview
      },
      closeModal () {
        this.showPreview = !this.showPreview
      },
      uploadImage (e) {
        let files = e.target.files || e.dataTransfer.files
        if (!files.length) return
        let file = files[0]
        this.show = false
        let formData = new FormData()
        formData.append('file', file)
        axios.post(`member/profilepic/${this.token}`, formData, {
          headers: {
            Authorization: '84cd7a9a97d4c1d8f6402f9389711560',
            'Content-Type': 'multipart/form-data; charset=utf-8; boundary=' + Math.random().toString().substr(2)
          }
        })
          .then((res) => {
            console.log('Image has been uploaded')
            this.$emit('message',
              {
                error: false,
                message: 'Image has been uploaded successfully'
              })
            this.show = true
            this.$emit('updateProfilePicture')
          })
          .catch((err) => {
            console.log(err)
            this.$emit('message',
              {
                error: true,
                message: 'Something went wrong'
              })
          })
      },
      getMemberPoints () {
        this.$axios({
          method: 'POST',
          url: `general/memberpoints/${this.user.ahlid}`,
          headers: {
            Authorization: '84cd7a9a97d4c1d8f6402f9389711560',
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },
          data: {
            token: this.token || ''
          }
        })
          .then((res) => {
            res.data.stars.forEach((starMonth) => {
              starMonth.monthyear = new Date(starMonth.monthyear);
            })
            debugger
            this.mypoints = res.data
            this.races = Object.entries(res.data.pointRaces)
            this.filterHistory()
            this.show = true
          })
          .catch((error) => {
            console.log(error)
          })
      },
      getFriends () {
        this.$axios({
          method: 'POST',
          url: `general/memberfriends/${this.user.ahlid}`,
          headers: {
            Authorization: '84cd7a9a97d4c1d8f6402f9389711560',
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },
          data: {
            token: this.token || ''
          }
        })
          .then((res) => {
            this.friends = res.data
          })
          .catch((error) => {
            console.log(error)
          })
      },
      getCurrentMonth () {
        let date = new Date()
        return date.getMonth()
      },
      convertMonth (number) {
        // Number is month 0 - Jan, 1 - Feb, etc. If current month is Nov or Dec turn to Jun and Feb
        if (number === 12) {
          number = 0
        }
        if (number === 13) {
          number = 1
        }
        switch (number) {
          case 0:
            return 'Jan'
          case 1:
            return 'Feb'
          case 2:
            return 'Mar'
          case 3:
            return 'Apr'
          case 4:
            return 'May'
          case 5:
            return 'Jun'
          case 6:
            return 'Jul'
          case 7:
            return 'Aug'
          case 8:
            return 'Sep'
          case 9:
            return 'Oct'
          case 10:
            return 'Nov'
          case 11:
            return 'Dec'
          default:
            return 'Error'
        }
      },
      getCurrentYear () {
        let date = new Date()
        return date.getFullYear()
      },
      filterPlacements (place) {
        for (let i = 0; i < this.mypoints.totalPlacements.length; i++) {
          if (+place === +this.mypoints.totalPlacements[i].place) {
            return this.mypoints.totalPlacements[i].count
          }
        }
        return 'None'
      },
      switchHistory (history) {
        this.history = history
        this.filterHistory()
      },
      filterHistory () {
        let arr = []
        let games = this.mypoints.tournamentHistory
        if (this.history === 'year') {
          for (let i = 0; i < games.length; i++) {
            if (games[i].date.search(this.getCurrentYear()) !== -1) {
              arr.push(games[i])
            }
          }
        } else if (this.history === 'thisMonth') {
          let thisMonth = this.getCurrentMonth()
          for (let i = 0; i < games.length; i++) {
            if (games[i].date.search(this.getCurrentYear()) !== -1 && games[i].date.search(this.convertMonth(thisMonth)) !== -1) {
              arr.push(games[i])
            }
          }
        } else if (this.history === 'lastMonth') {
          let thisMonth = this.getCurrentMonth() - 1
          for (let i = 0; i < games.length; i++) {
            if (games[i].date.search(this.getCurrentYear()) !== -1 && games[i].date.search(this.convertMonth(thisMonth)) !== -1) {
              arr.push(games[i])
            }
          }
        }
        if (arr.length === 0) {
          return false
        }
        return arr.slice(0, 10)
      },
      paginatedVenuesStats () {
        return this.mypoints.venueStats.slice(this.pagination, (this.pagination + 5))
      },
      paginatePlus () {
        if (this.mypoints.venueStats.length > (this.pagination + 5)) {
          this.pagination += 5
        }
      },
      paginateMinus () {
        if (this.pagination >= 5) {
          this.pagination -= 5
        }
      },
      compare () {
        let userOne = this.user.ahlid
        let userTwo = this.comparison
        if (userTwo) {
          this.$router.push({path: `/comparison/${userOne}/${userTwo}/`, params: { userOne, userTwo }})
        }
      },
      showMonth () {
        this.dropdownMonth = !this.dropdownMonth
      },
      showYear () {
        this.dropdownYear = !this.dropdownYear
      },
      showVenue () {
        this.dropdownVenue = !this.dropdownVenue
      },
      showTournamensFilter () {
        this.tournamensFilter = !this.tournamensFilter
      },
      removeFriend (id, index) {
        this.$axios({
          method: 'POST',
          url: `member/delfriend/${this.token}/${id}`,
          headers: {
            Authorization: '84cd7a9a97d4c1d8f6402f9389711560',
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },
          data: {
            token: this.token || ''
          }
        })
          .then((res) => {
            this.$emit('message',
              {
                error: res.data.error,
                message: res.data.message
              })
            this.friends.splice(index, 1)
          })
          .catch((error) => {
            this.$emit('message',
              {
                error: true,
                message: error.data.message
              })
          })
      }
    }
  }
</script>
